import { env } from "../../libs/utils/env";

export enum TypeRates {
    ANNUAL = "ANNUAL",
    SEMESTER = "SEMESTER",
}

export const MONTH_NAMES = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
];

export const LOADING_MESSAGE = "Estamos actualizando y validando tu cotización";

export const LOADING_TITLE = "Hola!";

export const ADDITIONAL_COVERAGE_LIFE = env.bool(
    process.env.REACT_APP_ADDITIONAL_COVERAGE_LIFE
);

export const ADDITIONAL_COVERAGE_PACKAGE_SLIP = env.int(
    process.env.REACT_APP_ADDITIONAL_COVERAGE_PACKAGE_SLIP
);

export const ADDITIONAL_COVERAGE_RMA = env.bool(
    process.env.REACT_APP_ADDITIONAL_COVERAGE_RMA
);
